/*! Fernando Pena - A11Y TOGGLE FUNCTIONALITY */

(function($){
	'use strict';

	/*-----------  ADD PROTOTYPE FOR OLDER BROWSERS -----------*/
	if (!Function.prototype.bind) {
		Function.prototype.bind = function(){
			var fn = this, args = Array.prototype.slice.call(arguments),
				object = args.shift();
			return function(){
				return fn.apply(object, args.concat(Array.prototype.slice.call(arguments)));
			};
		};
	}

	var A11yToggle = (function (){
		function A11yToggle(element, settings){
			var _ = this;

			_.defaults = {
				handler : false,
				toggleClass : "active",
				animation : "slide"
			};
			_.options = $.extend({}, _.defaults, settings);

			_.$toggle = $(element);
			_.$toggleContent = $(_.$toggle.data("toggle"));

			if(_.$toggle.length > 0){ _.init(); }
		}
		return A11yToggle;
	}());

	A11yToggle.prototype.init = function() {
		var _ = this;

		// Give multiple toggle instances differentiating ID's
		var idNum = 1;
		if($("[id^='a11yToggle']").last().length > 0){
			var highestNum = 0;

			$("[id^='a11yToggle']").each(function(){
				var currentNum = $(this).attr("id").split("tab")[1];

				highestNum = currentNum && highestNum < parseInt(currentNum, 10) ? parseInt(currentNum, 10) : highestNum;
			});

			idNum = highestNum + 1;
		}

		// Hide associated toggle content.
		_.$toggleContent.hide();

		_.$toggle.each(function(index){
			var $thisToggle = $(this),
				newToggleID = "a11yToggle"+idNum,
				newToggleContentID = "a11yToggle"+idNum+"Content";

			$thisToggle.attr({"id": newToggleID, "role": "button", "aria-expanded": "false", "aria-pressed":"false"});
			_.$toggleContent.attr("aria-hidden", "true");

			// Set ID to toggle's content if it doesn't have one and apply aria-controls value
			if(!_.$toggleContent[0].hasAttribute("id")){
				_.$toggleContent.attr("id", newToggleContentID);
				$thisToggle.attr("aria-controls", _.$toggleContent.attr("id"));
			}
			else {$thisToggle.attr("aria-controls", _.$toggleContent.attr("id"));}


			// Functionality for clicking toggle
			$thisToggle.on("click", function(e){
				e.preventDefault();

				if($thisToggle.hasClass(_.options.toggleClass)){

					$thisToggle.removeClass(_.options.toggleClass).attr({"aria-expanded": "false", "aria-pressed": "false"});
					_.$toggleContent.attr({"aria-hidden": "true", "tabindex": "-1"});

					// Check value for animation option
					if(_.options.animation === "fade"){
						_.$toggleContent.fadeOut();
					}
					else { _.$toggleContent.slideUp(); }

					// Remove automatic toggle handler if boolean is true
					if(_.options.handler){
						$("body").off("click", toggleHandler);
					}

				}
				else{

					$thisToggle.addClass(_.options.toggleClass).attr({"aria-expanded": "true", "aria-pressed": "true"});

					// Check value for animation option
					if(_.options.animation === "fade"){
						_.$toggleContent.fadeIn();
					}
					else { _.$toggleContent.slideDown(); }

					_.$toggleContent.focus().attr("aria-hidden", "false");

					// Remove automatic toggle handler if boolean is true
					if(_.options.handler){
						$("body").on("click", toggleHandler);
					}
				}
			});

			function toggleHandler(e){
				var $target = $(e.target);

				if (!$target.hasClass(_.options.toggleClass) && _.$toggleContent.has(e.target).length === 0) {
					$thisToggle.removeClass(_.options.toggleClass).attr("aria-expanded", "false");
					_.$toggleContent.slideUp().attr({"aria-hidden": "true", "tabindex": "-1"});
					$("body").off("click", toggleHandler);
				}
			}
		});

	}

	$.fn.a11yToggle = function() {
		var _ = this,
			opt = arguments[0],
			args = Array.prototype.slice.call(arguments, 1),
			l = _.length,
			i = 0,
			ret;

		for (i; i < l; i++) {
			if (typeof opt == 'object' || typeof opt == 'undefined') {
				_[i].a11yToggle = new A11yToggle(_[i], opt);
			} else {
				ret = _[i].a11yToggle[opt].apply(_[i].a11yToggle, args);
			}

			if (typeof ret != 'undefined') return ret;
		}

		return _;
	};
})(jQuery);
define("plugins/a11ytoggle", function(){});

